import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { find, get } from 'lodash';

// services
import { ApiService } from 'src/app/services/api.service';
import { QuestionService } from '../services/question.service';
import { ProcessorService } from '../services/processor.service';
import { NavigationService } from '../services/navigation.service';

// store
import { Store } from '@ngrx/store';
import {
	AppState,
	ADD_APP_ID,
	ADD_APPLICATION_ID,
	UPDATE_SIMULATE,
	UPDATE_PERSONA,
	UPDATE_AGENT,
	UPDATE_DECISION_INFO
} from '../app-reducer';

// reactive
import { Observable, throwError } from 'rxjs';
import { first, mergeMap, skipWhile } from 'rxjs/operators';

@Component({
	selector: 'debug',
	templateUrl: './debug-page.component.html'
})

export class DebugPageComponent implements OnInit {
	appState$: Observable<any>;
	processing = false;
	applyForm: FormGroup;
	skipPageValidation = true;
	agentEmailAddress: string;

	AgentId = (window['jhConfig'].ivuser !== '') ? window['jhConfig'].ivuser : 'webbs';
	AgentFirstName = (window['jhConfig'].firstname !== '') ? window['jhConfig'].firstname : 'Insurance';
	AgentLastName = (window['jhConfig'].lastname !== '') ? window['jhConfig'].lastname : 'Agent';
	AgentEmailAddress = (window['jhConfig'].email !== '') ? window['jhConfig'].email : 'fakemailaddy@jhancock.com'; // this.agentEmailAddress; <- removed because it's referenced before the variable is defined, which is throwing compiler errors

	// jumpAheadOptions: any = [];
	personaOptions: any = [];
	decisionOptions: any = [];
	constructor(
		public router: Router,
		private apiService: ApiService,
		public service: QuestionService,
		private processorService: ProcessorService,
		private navigationService: NavigationService,
		private store: Store<AppState>,
		private formBuilder: FormBuilder,
	) {
		this.appState$ = store.select('sections');

		// define form
		this.applyForm = this.formBuilder.group({
			agentEmail: [null],
			persona: [null],
			demoYes: [null],
			// jumpAhead: [null],
			decision: [null],
			// validatePages: [null] // [true],
		});
	}

	ngOnInit() {
		// do not allow entrance in production
		if (this.processorService.isProduction()) {

			const toUrl = '/express/welcome';
			this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
				this.router.navigate([toUrl]);
			});

			this.navigationService.nextSectionRelative('welcome');

			return true;
		}

		// for (let i = 0; i < this.router.config.length; i++) {
		// 	let path = this.router.config[i];
		// 	if (path.data && !path.data.blockConditionalClause) {
		// 		let pathArray = {
		// 			label: path.data.blockHeading,
		// 			value: path.path.substr(8)
		// 		}
		// 		this.jumpAheadOptions.push(pathArray);
		// 	}
		// }

		this.decisionOptions = [
			{ label: "Instant Decision - STP", value: 1 },
			{ label: "STP - Validation", value: 2 },
			{ label: "Incomplete", value: 2.5 },
			{ label: "Full UW", value: 3 },
		];
	}

	// utility
	onSubmit({ value, valid }: { value: any, valid: boolean }) {

		if (value.demoYes) {
			this.appState$.pipe(first()).subscribe((state: any) => {
				state.isDemo = true;
			});
		}

		this.AgentEmailAddress = this.applyForm.get('agentEmail').value || 'test@test.com';

		console.log('form submitted', value, valid);
		this.applyForm.markAllAsTouched();

		if (!valid) {
			return false;
		}

		// // TEMP skip page validation if checked
		// this.processorService.noValidation(this.applyForm.get('validatePages').value ? 'yes' : 'no');

		// update processing
		this.processing = true;
		if (value.decision) {
			const decisionInfo = [{
				TriagePathNumber: parseInt(value.decision),
				TriagePathName: value.decision,
				DecisionClassNumber: value.decision,
				DecisionClassName: 'SuperPreferred',
				Age: 50,
				Gender: 'Male',
				SmokerStatus: null
			}];
			//decisionInfo[0].TriagePathNumber = value.decision;
			this.store.dispatch({ type: UPDATE_DECISION_INFO, payload: { Rows: decisionInfo } });
		}

		const agentDeets: any = [];

		if (value.persona == 'ProposedInsured') {
			agentDeets.name = 'ProposedInsured';
			agentDeets.id = 2;
		} else if (value.persona == 'Agent') {
			agentDeets.name = 'Agent';
			agentDeets.id = 1;
		} else {
			agentDeets.name = 'Omnipotent';
			agentDeets.id = 0;
		}

		// update state
		this.store.dispatch({
			type: UPDATE_PERSONA,
			payload: {
				name: agentDeets.name,
				id: agentDeets.id
			}
		});

		// update state
		this.store.dispatch({
			type: UPDATE_SIMULATE,
			payload: { decision: value.decision ? value.decision : null }
		});

		// add Agent Info to state
		this.store.dispatch({
			type: UPDATE_AGENT,
			payload: {
				agentFirstname: this.AgentFirstName,
				agentLastname: this.AgentLastName,
				agentEmail: this.AgentEmailAddress,
				agentPhoneNumber: '555-55-5555',
			}
		});		

		// start eApp and subscribe to application changes
		this.subscribeToApplicationChanges();			
		
	}


	subscribeToApplicationChanges() {
		const req = {};
		this.apiService.startApplication(req).pipe(
			mergeMap((response: any) => {
				// error handling
				if (get(response, 'code') !== 200 || !get(response, 'data.ApplicationId')) {
					return throwError(response);
				}

				// update store
				this.store.dispatch({
					type: ADD_APP_ID,
					payload: get(response, 'data.AppAuthId')
				});

				// update store
				this.store.dispatch({
					type: ADD_APPLICATION_ID,
					payload: get(response, 'data.ApplicationId')
				});

				return this.appState$;
			}),
			first(),
			mergeMap((response: any) => {
				const requestPayload = {
					appAuthId: response.appAuthId,
					payload: {
						agentPhoneNumber: '555-55-5555',
						agentInfo: get(response, 'payload.agentInfo') || null
					}
				};
				const processAppPayload = {
					AppAuthId: response.appAuthId,
					AppId: response.appId,
					AgentId: this.AgentId,
					AgentFirstName: this.AgentFirstName,
					AgentLastName: this.AgentLastName,
					AgentEmail: this.AgentEmailAddress
				};

				this.apiService.processApplication(processAppPayload).subscribe(res => {
					console.log(res);
				});

				return this.apiService.saveInfo(requestPayload);

			}),
		).subscribe((response) => {

			// trigger observable holding block submissions until application pre-processing is done
			this.navigationService.readyToSubmit(true);

		}, (errorResponse) => {
			this.navigationService.nextSectionRelative('error');
		});

		// go to next section
		this.appState$.pipe(
			skipWhile((state: any) => {
				return (state.formData === null) || (state.questions === null)
			}),
			first()
		).subscribe((state) => {
			if (state.questions) {
			  	const routes = this.router.config;
			  	const newRoutes = routes.map(item => {
				const {data} = item;
				if (data && data.blockHeading && data.blockName && data.blockName !== 'intake' && data.hasOwnProperty('isProgressRoute')) {
				  const questionBlocks = find(state.questions, { Name: data.blockName });
				  item.data.blockCategory = questionBlocks.BlockCategory || null;
				  item.data.blockHeading = questionBlocks.DisplayName || null;
				}
				return item;
			  });
			  this.navigationService.buildNavStore(newRoutes);
			};
			// this.navigationService.nextSectionRelative(value.jumpAhead ? value.jumpAhead : 'proposed-insured');
			this.navigationService.nextSectionRelative('proposed-insured');
		});
	}	
}
